import React, { useState } from 'react';
import { Button, Modal, Form, Input, Select } from 'antd';

import { saveAs } from 'file-saver';
import format from 'xml-formatter';
import jsZip from 'jszip';

import { imageDownloadNameOptions as spdxDownloadNameOptions } from './imageDownloadOptionsModal';

const { Option } = Select;

export const MultipleSpdxDownloadModal = ({
  spdxDownloadModal,
  setSpdxDownloadModal,
  spdxDownloadName,
  setSpdxDownloadName,
  libraryData,
  imageDownloadIds,
  spdxDownloadType,
  setImageDownloadIds,
}) => {
  const [spdxFileName, setSpdxFileName] = useState(['model']);

  const getXmlData = (libraryItem) => {
    let js2xmlparser = require('js2xmlparser');
    const { metadata, tm30 } = libraryItem;

    const spdData = tm30.input.Wavelength?.map((data, index) => {
      const spdObj = {
        '@': {
          wavelength: data,
        },
        '#': tm30.input.SPD[index],
      };
      return spdObj;
    });

    const getHeaderInfo = (header) => {
      if (metadata[header]) {
        return metadata[header];
      } else {
        return 'N/A';
      }
    };

    const jsonToXmlObject = {
      '@': {
        xmlns: 'iestm2714',
        version: '1.0',
      },
      Header: {
        Manufacturer: getHeaderInfo('manufacturer'),
        CatalogNumber: getHeaderInfo('model'),
        Description: getHeaderInfo('description'),
        FileCreator: getHeaderInfo('creator'),
        Laboratory: getHeaderInfo('laboratory'),
        UniqueIdentifier: getHeaderInfo('identifier'),
        ReportNumber: getHeaderInfo('report_number'),
        ReportDate: getHeaderInfo('report_date'),
        DocumentCreationDate: getHeaderInfo('creation_date'),
        comments: getHeaderInfo('comments'),
      },
      SpectralDistribution: {
        SpectralQuantity: 'relative',
        BandwidthFWHM: '2.0',
        BandwidthCorrected: 'true',
        SpectralData: spdData,
      },
    };

    const json2xml = js2xmlparser.parse('IESTM2714', jsonToXmlObject);
    const formattedXml = format(json2xml, {
      indentation: '\t',
      collapseContent: true,
    });
    return formattedXml;
  };

  const handleSpdxDownload = () => {
    let zip = new jsZip();

    if (spdxDownloadType === 'checked') {
      let numberOfDownloads = 0;
      libraryData.forEach((libraryItem, index) => {
        if (imageDownloadIds.includes(libraryItem.id)) {
          numberOfDownloads++;
          const { metadata } = libraryItem;
          const formattedXml = getXmlData(libraryItem);

          const reportDownloadNamesToAppend = spdxFileName.map((downloadName) =>
            metadata[downloadName].replace(/[:,/]/g, '-')
          );
          const reportDownloadName = reportDownloadNamesToAppend.join('-');

          zip.file(`${reportDownloadName}.spdx`, formattedXml);

          if (numberOfDownloads === imageDownloadIds.length) {
            zip.generateAsync({ type: 'blob' }).then(function (content) {
              saveAs(content, spdxDownloadName);
            });
          }
        }
      });
    } else if (spdxDownloadType === 'full') {
      libraryData.forEach((libraryItem, index) => {
        const { metadata } = libraryItem;
        const formattedXml = getXmlData(libraryItem);

        const reportDownloadNamesToAppend = spdxFileName.map((downloadName) =>
          metadata[downloadName].replace(/[:,/]/g, '-')
        );
        const reportDownloadName = reportDownloadNamesToAppend.join('-');

        zip.file(`${reportDownloadName}.spdx`, formattedXml);

        if (index === libraryData.length - 1) {
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            saveAs(content, spdxDownloadName);
          });
        }
      });
    }

    setImageDownloadIds([]);
    setSpdxDownloadModal(false);
  };

  return (
    <Modal
      title='SPDx Download'
      visible={spdxDownloadModal}
      onCancel={() => setSpdxDownloadModal(false)}
      footer={[
        <Button
          style={{ marginRight: '1rem' }}
          key='cancel'
          onClick={() => setSpdxDownloadModal(false)}
        >
          Cancel
        </Button>,
        <Button
          key='download-dropdown'
          type='primary'
          onClick={handleSpdxDownload}
        >
          Download
        </Button>,
      ]}
    >
      <Form>
        <Form.Item
          label='SPDx file name'
          rules={[
            { required: true, message: 'At least one meta tag is required' },
          ]}
        >
          <Select
            style={{ width: '100%' }}
            mode='multiple'
            onChange={(value) => setSpdxFileName(value)}
            defaultValue={spdxFileName}
          >
            {spdxDownloadNameOptions.map((metaData) => {
              return (
                <Option
                  key={metaData.key + metaData.value}
                  value={metaData.value}
                >
                  {metaData.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item label='Folder name'>
          <Input
            value={spdxDownloadName}
            onChange={(event) => setSpdxDownloadName(event.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
